export const brazilianStates = [
  { sigla: "AC", nome: "ACRE" },
  { sigla: "AL", nome: "ALAGOAS" },
  { sigla: "AM", nome: "AMAZONAS" },
  { sigla: "AP", nome: "AMAPÁ" },
  { sigla: "BA", nome: "BAHIA" },
  { sigla: "CE", nome: "CEARÁ" },
  { sigla: "DF", nome: "DISTRITO FEDERAL" },
  { sigla: "ES", nome: "ESPÍRITO SANTO" },
  { sigla: "GO", nome: "GOIÁS" },
  { sigla: "MA", nome: "MARANHÃO" },
  { sigla: "MG", nome: "MINAS GERAIS" },
  { sigla: "MS", nome: "MATO GROSSO DO SUL" },
  { sigla: "MT", nome: "MATO GROSSO" },
  { sigla: "PA", nome: "PARÁ" },
  { sigla: "PB", nome: "PARAÍBA" },
  { sigla: "PE", nome: "PERNAMBUCO" },
  { sigla: "PI", nome: "PIAUÍ" },
  { sigla: "PR", nome: "PARANÁ" },
  { sigla: "RJ", nome: "RIO DE JANEIRO" },
  { sigla: "RN", nome: "RIO GRANDE DO NORTE" },
  { sigla: "RO", nome: "RONDÔNIA" },
  { sigla: "RR", nome: "RORAIMA" },
  { sigla: "RS", nome: "RIO GRANDE DO SUL" },
  { sigla: "SC", nome: "SANTA CATARINA" },
  { sigla: "SP", nome: "SÃO PAULO" },
  { sigla: "SE", nome: "SERGIPE" },
  { sigla: "TO", nome: "TOCANTINS" }
];

export const brazilianStatesAndCountry = [
  { sigla: "AC", nome: "ACRE" },
  { sigla: "AL", nome: "ALAGOAS" },
  { sigla: "AM", nome: "AMAZONAS" },
  { sigla: "AP", nome: "AMAPÁ" },
  { sigla: "BA", nome: "BAHIA" },
  { sigla: "BR", nome: "BRASIL" },
  { sigla: "CE", nome: "CEARÁ" },
  { sigla: "DF", nome: "DISTRITO FEDERAL" },
  { sigla: "ES", nome: "ESPÍRITO SANTO" },
  { sigla: "GO", nome: "GOIÁS" },
  { sigla: "MA", nome: "MARANHÃO" },
  { sigla: "MG", nome: "MINAS GERAIS" },
  { sigla: "MS", nome: "MATO GROSSO DO SUL" },
  { sigla: "MT", nome: "MATO GROSSO" },
  { sigla: "PA", nome: "PARÁ" },
  { sigla: "PB", nome: "PARAÍBA" },
  { sigla: "PE", nome: "PERNAMBUCO" },
  { sigla: "PI", nome: "PIAUÍ" },
  { sigla: "PR", nome: "PARANÁ" },
  { sigla: "RJ", nome: "RIO DE JANEIRO" },
  { sigla: "RN", nome: "RIO GRANDE DO NORTE" },
  { sigla: "RO", nome: "RONDÔNIA" },
  { sigla: "RR", nome: "RORAIMA" },
  { sigla: "RS", nome: "RIO GRANDE DO SUL" },
  { sigla: "SC", nome: "SANTA CATARINA" },
  { sigla: "SP", nome: "SÃO PAULO" },
  { sigla: "SE", nome: "SERGIPE" },
  { sigla: "TO", nome: "TOCANTINS" }
];

export const listTypeCriticism = [
  { id: "mensagem", nome: "Novo Chat" },
  { id: "critica", nome: "Nova Crítica" }
];
